import { RobotExcitedOutlineIcon } from './RobotExcitedOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8013E3FE-34B6-49F3-919B-85A5E0A5873C
 * name robot-excited-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-excited-outline.svg
 * tags
 */
export const EmoticonRobotExcitedOutlineIcon = RobotExcitedOutlineIcon;
export default EmoticonRobotExcitedOutlineIcon